(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inabox-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.inaBoxReviewLightboxReady) {
      window.inaBoxReviewLightboxReady = true;
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-review-lightbox-open]');
        if (trigger) {
          const dialog = trigger.closest('section')?.querySelector('[data-review-lightbox]') || document.querySelector('[data-review-lightbox]');
          const image = dialog?.querySelector('[data-review-lightbox-image]');
          if (!dialog || !image) return;
          image.src = trigger.dataset.reviewImageSrc || '';
          image.alt = trigger.dataset.reviewImageAlt || 'Customer review image';
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
          return;
        }
        const close = event.target.closest('[data-review-lightbox-close]');
        if (close) {
          const dialog = close.closest('[data-review-lightbox]');
          if (typeof dialog?.close === 'function') dialog.close();
          else dialog?.removeAttribute('open');
          return;
        }
        if (event.target.matches?.('[data-review-lightbox]')) {
          if (typeof event.target.close === 'function') event.target.close();
          else event.target.removeAttribute('open');
        }
      });
    }
    const initialize = (root) => {
      root.querySelectorAll('[data-happy-cuties-carousel]').forEach((carousel) => {
        if (carousel.dataset.initialized === 'true') return;
        carousel.dataset.initialized = 'true';
        const track = carousel.querySelector('[data-happy-cuties-track]');
        const previous = carousel.querySelector('[data-happy-cuties-previous]');
        const next = carousel.querySelector('[data-happy-cuties-next]');
        const move = (direction) => track.scrollBy({ left: direction * Math.max(track.clientWidth * .82, 280), behavior: 'smooth' });
        previous?.addEventListener('click', () => move(-1));
        next?.addEventListener('click', () => move(1));
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const formatWhatsAppMoney = (cents, currency) => {
    const amount = new Intl.NumberFormat('en-AE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100);
    return `${currency} ${amount}`;
  };

  const applyDiscountCode = (input) => {
    const code = input.value.trim();
    if (!code) {
      input.setCustomValidity('Enter a discount code.');
      input.reportValidity();
      return;
    }
    input.setCustomValidity('');
    const root = window.Shopify.routes.root || '/';
    const cartPath = `${root}cart`;
    window.location.assign(`${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(cartPath)}`);
  };

  const setCartLineQuantity = async (line, quantity) => {
    if (!line || line.dataset.cartUpdating === 'true') return;
    line.dataset.cartUpdating = 'true';
    line.querySelectorAll('button, input').forEach((control) => { control.disabled = true; });
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.dataset.cartKey, quantity })
      });
      if (!response.ok) throw new Error('Unable to update cart');
      window.location.reload();
    } catch (error) {
      line.dataset.cartUpdating = 'false';
      line.querySelectorAll('button, input').forEach((control) => { control.disabled = false; });
      window.alert('Please try updating your cart again.');
    }
  };

  const normalizeAddonQuantities = async () => {
    const lines = [...document.querySelectorAll('[data-cart-addon-line="true"][data-cart-quantity-over-limit="true"]')];
    if (!lines.length) return;
    for (const line of lines) {
      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.dataset.cartKey, quantity: 1 })
      });
    }
    window.location.reload();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeAddonQuantities, { once: true });
  } else {
    normalizeAddonQuantities();
  }

  document.addEventListener('click', async (event) => {
    const applyDiscount = event.target.closest('[data-apply-discount]');
    if (applyDiscount) {
      const input = document.querySelector('[data-discount-code]');
      if (input) applyDiscountCode(input);
      return;
    }

    const removeDiscount = event.target.closest('[data-remove-discount]');
    if (removeDiscount) {
      const originalLabel = removeDiscount.textContent;
      removeDiscount.disabled = true;
      removeDiscount.textContent = removeDiscount.dataset.removingLabel;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: '' })
        });
        if (!response.ok) throw new Error('Unable to remove discount');
        window.location.reload();
      } catch (error) {
        removeDiscount.disabled = false;
        removeDiscount.textContent = originalLabel;
        window.alert(removeDiscount.dataset.errorLabel);
      }
      return;
    }

    const whatsappCheckout = event.target.closest('[data-whatsapp-checkout]');
    if (whatsappCheckout) {
      const dialog = document.getElementById(whatsappCheckout.dataset.whatsappDialogTarget);
      if (dialog?.showModal) dialog.showModal();
      return;
    }

    const closeDialog = event.target.closest('[data-whatsapp-close]');
    if (closeDialog) {
      closeDialog.closest('dialog')?.close();
      return;
    }

    const quantityButton = event.target.closest('[data-quantity-step]');
    if (quantityButton) {
      const line = quantityButton.closest('[data-cart-line]');
      const input = line?.querySelector('[data-cart-quantity]');
      if (!input) return;
      const nextQuantity = Math.max(1, Number(input.value || 1) + Number(quantityButton.dataset.quantityStep));
      if (nextQuantity === Number(input.value)) return;
      input.value = nextQuantity;
      await setCartLineQuantity(line, nextQuantity);
      return;
    }

    const galleryButton = event.target.closest('[data-upsell-gallery-step]');
    if (galleryButton) {
      const gallery = galleryButton.closest('[data-upsell-gallery]');
      const slides = [...gallery.querySelectorAll('[data-upsell-gallery-slide]')];
      if (!slides.length) return;
      const currentIndex = Math.max(0, slides.findIndex((slide) => !slide.hidden));
      const nextIndex = (currentIndex + Number(galleryButton.dataset.upsellGalleryStep) + slides.length) % slides.length;
      slides.forEach((slide, index) => { slide.hidden = index !== nextIndex; });
      const counter = gallery.querySelector('[data-upsell-gallery-counter]');
      if (counter) counter.textContent = `${nextIndex + 1} / ${slides.length}`;
      return;
    }

    const button = event.target.closest('[data-cart-addon]');
    if (!button || button.disabled) return;
    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';
    try {
      const item = { id: Number(button.dataset.cartAddon), quantity: 1 };
      if (button.dataset.cartAddonNameRequired === 'true') {
        const nameInput = button.closest('[data-engraving-upsell]')?.querySelector('[data-engraving-name]');
        const engravingName = nameInput?.value.trim();
        if (!engravingName) {
          nameInput?.setCustomValidity('Please enter the name to engrave.');
          nameInput?.reportValidity();
          throw new Error('Please enter the name to engrave.');
        }
        nameInput.setCustomValidity('');
        item.properties = { 'Name to engrave': engravingName };
      }
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] })
      });
      if (!response.ok) throw new Error('Unable to add this option');
      window.location.reload();
    } catch (error) {
      button.disabled = false;
      button.textContent = originalLabel;
      window.alert('Please try adding this option again.');
    }
  });

  document.addEventListener('keydown', (event) => {
    const input = event.target.closest('[data-discount-code]');
    if (!input || event.key !== 'Enter') return;
    event.preventDefault();
    applyDiscountCode(input);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    const line = input.closest('[data-cart-line]');
    const quantity = Math.max(1, Number(input.value || 1));
    input.value = quantity;
    setCartLineQuantity(line, quantity);
  });

  let noteSaveTimer;
  document.addEventListener('input', (event) => {
    const note = event.target.closest('[data-cart-note]');
    if (!note) return;
    const status = document.querySelector('[data-cart-note-status]');
    window.clearTimeout(noteSaveTimer);
    if (status) status.textContent = note.dataset.savingLabel;
    noteSaveTimer = window.setTimeout(async () => {
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
        if (!response.ok) throw new Error('Unable to save note');
        if (status) status.textContent = note.dataset.savedLabel;
      } catch (error) {
        if (status) status.textContent = note.dataset.saveErrorLabel;
      }
    }, 450);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-whatsapp-order-form]');
    if (!form) return;
    event.preventDefault();
    if (!form.reportValidity()) return;

    const dialog = form.closest('[data-whatsapp-order-dialog]');
    const currency = dialog.dataset.currency || 'AED';
    const orderLines = [];
    let subtotal = 0;
    document.querySelectorAll('[data-cart-line]').forEach((line) => {
      const quantity = Number(line.querySelector('.cart-quantity')?.value || 0);
      if (quantity < 1) return;
      const unitPrice = Number(line.dataset.cartUnitPrice || 0);
      const lineTotal = unitPrice * quantity;
      subtotal += lineTotal;
      const icon = line.dataset.whatsappIcon === 'delivery' ? '\u{1F69A}' : '\u{1F4E6}';
      const details = line.dataset.cartDetails?.trim();
      const detailsText = details ? ` (${details})` : '';
      orderLines.push(`${icon} ${line.dataset.whatsappTitle}${detailsText} \u00D7${quantity} \u2014 ${formatWhatsAppMoney(lineTotal, currency)}`);
    });

    const fields = new FormData(form);
    const phone = fields.get('customer_phone')?.trim();
    const email = fields.get('customer_email')?.trim();
    const note = document.querySelector('#CartNote')?.value.trim();
    const total = formatWhatsAppMoney(subtotal, currency);
    const message = [
      `Hi Ina Box! \u{1F49D} I'd love to order:`,
      '',
      ...orderLines,
      '\u{1F69A} Free UAE delivery in 1-2 days',
      '',
      '\u{1F4CB} Order Summary',
      `Subtotal: ${total}`,
      'Delivery: Free UAE delivery in 1-2 days',
      `Total: *${total}*`,
      '',
      '\u{1F464} Customer Details',
      `Name: ${fields.get('customer_name').trim()}`,
      phone ? `Phone: ${phone}` : null,
      email ? `Email: ${email}` : null,
      `Address: ${fields.get('customer_address').trim()}`,
      note ? '' : null,
      note ? '\u{1F4DD} Gift Details & Preferences' : null,
      note || null,
      '',
      'Thank you! \u{1F60A}'
    ].filter((line) => line !== null).join('\n');

    const whatsappParams = `phone=${encodeURIComponent(dialog.dataset.whatsappNumber)}&text=${encodeURIComponent(message)}`;
    const isMobileDevice = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
    if (isMobileDevice) {
      window.location.href = `whatsapp://send?${whatsappParams}`;
    } else {
      window.open(`https://web.whatsapp.com/send?${whatsappParams}`, '_blank', 'noopener,noreferrer');
    }
    dialog.close();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  if (!window.inaBoxReviewLightboxReady) {
    window.inaBoxReviewLightboxReady = true;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-review-lightbox-open]');
      if (trigger) {
        const dialog = trigger.closest('section')?.querySelector('[data-review-lightbox]') || document.querySelector('[data-review-lightbox]');
        const image = dialog?.querySelector('[data-review-lightbox-image]');
        if (!dialog || !image) return;
        image.src = trigger.dataset.reviewImageSrc || '';
        image.alt = trigger.dataset.reviewImageAlt || 'Customer review image';
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        return;
      }
      const close = event.target.closest('[data-review-lightbox-close]');
      if (close) {
        const dialog = close.closest('[data-review-lightbox]');
        if (typeof dialog?.close === 'function') dialog.close();
        else dialog?.removeAttribute('open');
        return;
      }
      if (event.target.matches?.('[data-review-lightbox]')) {
        if (typeof event.target.close === 'function') event.target.close();
        else event.target.removeAttribute('open');
      }
    });
  }

  if (!window.inaBoxProductGalleryReady) {
    window.inaBoxProductGalleryReady = true;
    const showProductImage = (gallery, requestedIndex) => {
      const slides = Array.from(gallery.querySelectorAll('[data-product-gallery-slide]'));
      if (!slides.length) return;
      const index = (requestedIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      const thumbnails = Array.from(gallery.querySelectorAll('[data-product-gallery-thumbnail]'));
      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const active = thumbnailIndex === index;
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
      gallery.dataset.galleryIndex = String(index);
      const counter = gallery.querySelector('[data-product-gallery-current]');
      if (counter) counter.textContent = String(index + 1);
    };
    const moveProductImage = (gallery, direction) => {
      showProductImage(gallery, Number(gallery.dataset.galleryIndex || 0) + direction);
    };
    document.addEventListener('click', (event) => {
      const thumbnail = event.target.closest('[data-product-gallery-thumbnail]');
      if (thumbnail) {
        const gallery = thumbnail.closest('[data-product-gallery]');
        if (gallery) showProductImage(gallery, Number(thumbnail.dataset.galleryTarget || 0));
        return;
      }
      const arrow = event.target.closest('[data-product-gallery-previous], [data-product-gallery-next]');
      if (!arrow) return;
      const gallery = arrow.closest('[data-product-gallery]');
      if (!gallery) return;
      moveProductImage(gallery, arrow.hasAttribute('data-product-gallery-next') ? 1 : -1);
    });
    document.addEventListener('keydown', (event) => {
      const gallery = event.target.closest('[data-product-gallery]');
      if (!gallery) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        moveProductImage(gallery, event.key === 'ArrowRight' ? 1 : -1);
      }
    });
    document.addEventListener('pointerdown', (event) => {
      const main = event.target.closest('[data-product-gallery-main]');
      if (main) main.dataset.swipeStart = String(event.clientX);
    });
    document.addEventListener('pointerup', (event) => {
      const main = event.target.closest('[data-product-gallery-main]');
      if (!main || main.dataset.swipeStart === undefined) return;
      const distance = event.clientX - Number(main.dataset.swipeStart);
      delete main.dataset.swipeStart;
      if (Math.abs(distance) < 45) return;
      const gallery = main.closest('[data-product-gallery]');
      if (gallery) moveProductImage(gallery, distance < 0 ? 1 : -1);
    });
  }

  if (!window.inaBoxProductNavigationReady) {
    window.inaBoxProductNavigationReady = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-product-section-link]');
      if (!link) return;
      const section = document.getElementById(link.dataset.productSectionLink);
      if (!section) return;
      event.preventDefault();
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.history.replaceState(null, '', `#${section.id}`);
    });
    document.addEventListener('click', (event) => {
      const reviewLink = event.target.closest('a[href="#write-review"]');
      if (!reviewLink) return;
      const form = document.querySelector('[data-product-review-form]');
      if (form) form.open = true;
    });
    const reviewForm = document.querySelector('[data-product-review-form]');
    if (reviewForm && (window.location.hash === '#write-review' || new URLSearchParams(window.location.search).has('contact_posted'))) reviewForm.open = true;
  }

  if (!window.inaBoxStickyBuyReady) {
    window.inaBoxStickyBuyReady = true;
    const syncStickyBuy = () => {
      const sticky = document.querySelector('[data-product-sticky-buy]');
      const mainForm = document.querySelector('.product-detail form[action*="/cart/add"]');
      if (!sticky || !mainForm) return;
      const mainVariant = mainForm.querySelector('[name="id"]');
      const mainQuantity = mainForm.querySelector('[name="quantity"]');
      const stickyVariant = sticky.querySelector('[data-sticky-variant]');
      const stickyQuantity = sticky.querySelector('[data-sticky-quantity]');
      const buyNow = sticky.querySelector('[data-sticky-buy-now]');
      const variantId = mainVariant ? mainVariant.value : stickyVariant.value;
      const quantity = sticky.dataset.productAddon === 'true' ? 1 : Math.max(1, Number(mainQuantity?.value || 1));
      stickyVariant.value = variantId;
      stickyQuantity.value = String(quantity);
      if (buyNow && !buyNow.classList.contains('is-disabled')) buyNow.href = `/cart/${variantId}:${quantity}`;
    };
    document.addEventListener('click', (event) => {
      const buyNow = event.target.closest('[data-sticky-buy-now]');
      if (!buyNow || buyNow.classList.contains('is-disabled')) return;
      const mainForm = document.querySelector('.product-detail form[action*="/cart/add"]');
      if (!mainForm) return;
      event.preventDefault();
      let returnTo = mainForm.querySelector('input[name="return_to"]');
      if (!returnTo) {
        returnTo = document.createElement('input');
        returnTo.type = 'hidden';
        returnTo.name = 'return_to';
        mainForm.appendChild(returnTo);
      }
      returnTo.value = '/cart';
      buyNow.classList.add('is-disabled');
      buyNow.setAttribute('aria-busy', 'true');
      buyNow.textContent = 'Opening cart...';
      HTMLFormElement.prototype.submit.call(mainForm);
    });
    document.addEventListener('change', (event) => {
      if (event.target.closest('.product-detail form[action*="/cart/add"]')) syncStickyBuy();
    });
    document.addEventListener('input', (event) => {
      if (event.target.closest('.product-detail form[action*="/cart/add"]')) syncStickyBuy();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncStickyBuy);
    else syncStickyBuy();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-wishlist"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.getElementById('InaWishlist');
    if (!root) return;
    const key = 'inabox-wishlist';
    const getItems = () => {
      try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (error) { return []; }
    };
    const element = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    };
    const render = () => {
      const items = getItems();
      root.replaceChildren();
      if (!items.length) {
        const empty = element('div', 'empty-state');
        empty.append(element('h2', '', root.dataset.emptyHeading), element('p', '', root.dataset.emptyText));
        const link = element('a', 'primary-cta', root.dataset.browseLabel);
        link.href = root.dataset.browseUrl;
        empty.append(link);
        root.append(empty);
        return;
      }
      items.forEach((item) => {
        const card = element('article', 'product-card pink');
        const link = element('a', 'card-image-link');
        link.href = item.url;
        if (item.image) {
          const image = element('img');
          image.src = item.image;
          image.alt = item.title;
          image.loading = 'lazy';
          link.append(image);
        }
        const title = element('h3');
        const titleLink = element('a', '', item.title);
        titleLink.href = item.url;
        title.append(titleLink);
        const price = element('div', 'price-row');
        price.append(element('strong', '', item.price));
        const view = element('a', 'primary-cta full-button', 'View product');
        view.href = item.url;
        const remove = element('button', 'wishlist-button', 'Remove');
        remove.type = 'button';
        remove.addEventListener('click', () => {
          localStorage.setItem(key, JSON.stringify(getItems().filter((saved) => saved.handle !== item.handle)));
          render();
        });
        card.append(link, title, price, view, remove);
        root.append(card);
      });
    };
    render();
  })();

  } catch(e) { console.error(e); }
})();
})();
